module.exports = __webpack_public_path__ + "static/media/49850027-44g1wSgs.f49425da.JPG";